import Roles from '@/shared/utils/roles'
import { derivaConsulta as deriva } from '@/shared/utils/consultaReadonly'

// As roles de ESCRITA das Despesas Diversos -- as mesmas do `expectedRoles` das rotas de
// operacao do modulo. Par do `rolesEscritaViagem.js` da Despesa Viagem.
export const ROLES_ESCRITA_DIVERSOS = [
  Roles.RW_ZPAG_DIVERSOS,
  Roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL,
  Roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL,
  Roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL,
  Roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL
]

export const derivaConsulta = (query, hasRole) => deriva(query, hasRole, ROLES_ESCRITA_DIVERSOS)



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/rolesEscritaDiversos.js